import 'idempotent-babel-polyfill';

const setPage = document.querySelector('#content-indicator');

if (setPage){
  const getPostsContent = (() => {
    const config = {
      api: window.location.origin + '/wp-json/wp/v2/dgt_mkt_indicator',
      startPage: 0,
      postsPerPage: 5
    };

    let postsLoaded = false;
    let postsContent = document.querySelector('.posts');
    let btnLoadMore = document.querySelector('.btn-s');
    let btnText = document.querySelector('.btn-s-text');

    const loadContent = function() {

        ++config.startPage;

        const params = {
          page: config.startPage,
          per_page: config.postsPerPage,
        }
        const getApiUrl = (url) => {
          let apiUrl = new URL(url);
          apiUrl.search = new URLSearchParams(params).toString();
          return apiUrl;
        };

        const loadPosts = async () => {
          btnText.innerText = 'Carregando ...';
          btnText.classList.add('loading');
          btnLoadMore.classList.add('loading');
          const url = getApiUrl(config.api);
          const request = await fetch(url);
          const posts = await request.json();

          const postsHtml = renderPost(posts);
          postsContent.innerHTML += postsHtml;

          postsLoaded = true;
        };

        const renderPost = (posts) => {
          btnText.innerText = 'Carregar Mais';
          btnText.classList.remove('loading');
          btnLoadMore.classList.remove('loading');
          let postHtml = '';
          for(let post of posts) {
            postHtml += postContent(post);
          };
          return postHtml;
        };

        const postContent = (post) => {
          return `
            <li id="post-${post.id}" class="">
                <div class="list-news">
                    <div class="container">
                        <div class="content-news no-thumbnail">
                            <div class="category">
                                                </div>
                            <a href="${post.link}" title="${post.title.rendered}">
                                <h2 class="title-indicator">${post.title.rendered}</h2>
                                <div class="resumo">
                                  ${post.excerpt.rendered}
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </li>`
          ;
        };

        loadPosts();
    };

    btnLoadMore.addEventListener('click', function() {
      loadContent();
    });

    return {
      init: loadContent
    };


  })();

  getPostsContent.init();

};

